import {Avatar, Box, Flex, HStack, Text, VStack} from '@chakra-ui/react'
import {useDispatch, useSelector} from 'react-redux'
import AvatarDefault from '@assets/images/avatar-msg-part-two.png'
import {useEffect, useState} from 'react'
import {
  updateAudio,
  updateMessages,
} from '@redux/learn-part-three/learnPartThree'
import OutlineMsg from './OutlineMsg'
import BandScoreMsg from './BandScoreMsg'
import UserMsg from './UserMsg'
import ChunkingMsg from './ChunkingMsg'

export default function Summary() {
  const {currentContent, isLoadingBot, messages} = useSelector(
    (state: any) => state.learnPartThree,
  )
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!currentContent) return
    getSummaryData()
  }, [currentContent])

  const getSummaryData = async () => {
    const msgs = currentContent?.data

    const audioData = {
      time: Date.now(),
      url: msgs[0]?.data?.audio,
    }

    dispatch(updateAudio(audioData))
    dispatch(updateMessages(msgs))
  }

  const renderMessage = (msg: any, index: number) => {
    switch (msg?.message_type) {
      case 'TEXT':
        return (
          <HStack key={index} align="start" spacing={4}>
            <Avatar
              src={AvatarDefault}
              size="sm"
              borderRadius={'50%'}
              border={'2px solid #E4E7EC'}
            />
            <VStack
              maxWidth={'80%'}
              align="start"
              spacing={4}
              bg={'white'}
              p={'16px'}
              borderRadius={'12px'}>
              <Text fontSize={'16px'}>{msg?.data?.text}</Text>
            </VStack>
          </HStack>
        )
      case 'USER':
        return <UserMsg key={index} msg={msg} />
      case 'SAMPLE_FRAME':
        return <OutlineMsg key={index} msg={msg} />
      case 'SCORING':
        return <BandScoreMsg key={index} msg={msg?.data} />
      case 'CHUNKING':
        return <ChunkingMsg key={index} msg={msg?.data} />
      default:
        return <Box key={index}></Box>
    }
  }

  return (
    <Flex flexDirection={'column'} gap={4}>
      {!isLoading &&
        messages.map((msg: any, index: number) => renderMessage(msg, index))}
      {(isLoading || isLoadingBot) && (
        <HStack align="start" spacing={4}>
          <Avatar
            src={AvatarDefault}
            size="sm"
            borderRadius={'50%'}
            border={'2px solid #E4E7EC'}
          />
          <Box bg={'white'} p={'16px'} borderRadius={'12px'}>
            <Box className="loading-message"></Box>
          </Box>
        </HStack>
      )}
    </Flex>
  )
}
